import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from '@src/app/core/internationalization/translation-keys';

export class OnboardingDocumentsTranslationService {
  constructor(private translate: TranslateService) {}

  tk = TranslationKeys;

  getTranslationForDocument(stage: string, documentName: string): string {
    const translations: Record<string, Record<string, string>> = {
      CompanyDocuments: {
        ArticlesOfIncorporationAndAmendments: this.tk.Onboarding.SocialContractContractualChanges,
        LegalRepresentativesDocumentation: this.tk.Onboarding.DocumentationLegalRepresentatives,
        PartnersIncomeTax: this.tk.Onboarding.IncomeTaxPartners,
        CorporateStructureMap: this.tk.Onboarding.CorporateStructureMap,
        ExecutiveOrganogram: this.tk.Onboarding.ExecutiveOrganizationalChart,
        HoldingCompanyArticlesOfIncorporation:
          this.tk.General.SocialContractAndContractualAmendmentsOfTheHolding,
        FinancialStatements3YearsForHolding: this.tk.General.HoldingFinancialStatementsLast3Years,
      },
      BillingDocuments: {
        AnnualBilling: this.tk.Onboarding.AnnualBilling,
        CurrentYearPartialBilling: this.tk.Onboarding.PartialBillingCurrentYear,
      },
      FinancialStatements: {
        BalanceSheetIncomeStatementCashFlow: this.tk.Onboarding.BalanceSheetIncomeStatementDdc,
        MonthlyBalanceSheetsLast3Years: this.tk.Onboarding.MonthlyBalanceSheetsLast3Years,
        BusinessPlan: this.tk.Onboarding.BusinessPlan,
        Projections: this.tk.Onboarding.Projections,
        MultiYearFinancialProjection: this.tk.Onboarding.MultiYearFinancialProjection,
        BacklogWithBalanceAndProjection: this.tk.Onboarding.BacklogWithBalanceProjection,
        Indebtedness: this.tk.Onboarding.Debt,
        IndebtednessProjection: this.tk.Onboarding.DebtProjection,
        LoanContracts: this.tk.Onboarding.LoanAgreements,
      },
      Projects: {
        PublicNotice: this.tk.Onboarding.Edital,
        LoanContracts: this.tk.Onboarding.LoanAgreements,
        PhysicalFinancialSchedule: this.tk.Onboarding.PhysicalFinancialSchedule,
        ConsortiumConstitutionDocument: this.tk.Onboarding.ConsortiumIncorporationDocumentIA,
        GeneralInformation: this.tk.Onboarding.GeneralInformationSAE,
      },
      GuaranteeDocuments: {
        RealEstateRegistrationsAndAppraisals: this.tk.Onboarding.PropertiesRegistrationsEvaluations,
        AccountsReceivable: this.tk.Onboarding.AccountsReceivableCDMR,
        CustomerContracts: this.tk.Onboarding.ContractsCustomers,
      },
      GeneralDocuments: {
        MarketStudies: this.tk.Onboarding.MarketStudies,
        InstitutionalPresentation: this.tk.Onboarding.InstitutionalPresentation,
        CommercialPresentations: this.tk.Onboarding.CommercialPresentations,
        ProductServiceInformation: this.tk.Onboarding.PresentationsInformationProductsServices,
        CompanyProductServiceImages: this.tk.Onboarding.CompanyImagesProductsServices,
        BrandManual: this.tk.Onboarding.BrandManual,
        LogosVectorJpgPng: this.tk.Onboarding.LogosVectorJpgPngFormats,
        BrandPitchDeck: this.tk.Onboarding.BrandPitchDeck,
      },
    };

    if (stage in translations) {
      const stageDocuments = translations[stage];
      if (documentName in stageDocuments) {
        return this.translate.instant(stageDocuments[documentName]);
      }
    }

    return documentName;
  }

  getTranslationForStage(stage: string): string {
    const stageTranslations: Record<string, string> = {
      CompanyDocuments: this.translate.instant(this.tk.Onboarding.CompanyDocuments1),
      GeneralDocuments: this.translate.instant(this.tk.Onboarding.GeneralDocuments1),
      BillingDocuments: this.translate.instant(this.tk.Onboarding.BillingDocuments1),
      FinancialStatements: this.translate.instant(this.tk.Onboarding.FinancialStatements1),
      Projects: this.translate.instant(this.tk.Onboarding.Projects1),
      GuaranteeDocuments: this.translate.instant(this.tk.Onboarding.WarrantyDocuments1),
    };

    return stageTranslations[stage] ? this.translate.instant(stageTranslations[stage]) : stage;
  }
}
